import React, { useState } from 'react'
import { makeStyles, Theme, Typography, Link } from '@material-ui/core/'
import { FormattedMessage } from 'react-intl'
import messages from '@configurator-messages'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import { contactEmail } from '@src/routes/Configurators/utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  modalBodyContainer: {
    padding: theme.spacing(4),
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
    },
  },
  contentPadding: {
    padding: theme.spacing(6, 0, 0),
  },
  modalLink: {
    cursor: 'pointer',
  },
}))

const PerformanceGuaranteeModal = () => {
  const classes = useStyles()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <>
      <Link onClick={() => setIsModalOpen(true)} className={classes.modalLink}>
        <FormattedMessage {...messages.OUR_PERFORMANCE_GUARANTEE} />
      </Link>
      {isModalOpen ? (
        <ResponsiveModal
          size={ModalSizes.Large}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          renderTitle={() => (
            <Typography variant="h2" component="h2">
              <FormattedMessage {...messages.PERFORMANCE_GUARANTEE} />
            </Typography>
          )}
        >
          <div className={classes.modalBodyContainer}>
            <FormattedMessage {...messages.PERFORMANCE_GUARANTEE_FIRST} />

            <div className={classes.contentPadding}>
              <FormattedMessage {...messages.PERFORMANCE_GUARANTEE_SECOND} />
              &nbsp;
              <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              &nbsp;
              <FormattedMessage {...messages.PERFORMANCE_GUARANTEE_THIRD} />
            </div>
          </div>
        </ResponsiveModal>
      ) : null}
    </>
  )
}

export default PerformanceGuaranteeModal
